import React from "react";
import PropTypes from "prop-types";

/**
 * 실측 항목 리스트 (label - value cm).
 * 상품 상세 인라인 섹션과 실측 안내 모달에서 공용으로 사용됩니다.
 * @param {Array<{label: string, key?: string, value: number|null}>} measurements
 * @param {string} [className]
 */
export default function ProductMeasurementList({ measurements, className }) {
  if (!Array.isArray(measurements) || measurements.length === 0) {
    return null;
  }

  return (
    <dl className={`Product-measurement-list ${className ?? ""}`}>
      {measurements.map((item, index) => (
        <div
          className="Product-measurement-row"
          key={item.key ?? item.label ?? index}
        >
          <dt className="Product-measurement-label">{item.label}</dt>
          <dd className="Product-measurement-value">
            {item.value != null ? `${item.value} cm` : "–"}
          </dd>
        </div>
      ))}
    </dl>
  );
}

ProductMeasurementList.propTypes = {
  measurements: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      key: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
  ),
  className: PropTypes.string,
};
